import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { buttonClassName } from '../button/buttonClasses';

interface WizardStepProps {
    label: string;
    isActive?: boolean;
    isComplete?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
    className?: string;
    zIndex?: number;
}

export const WizardStep: React.FC<WizardStepProps> = ({
    label,
    isActive = false,
    isComplete = false,
    isFirst = false,
    isLast = false,
    className = '',
    zIndex = 0,
}) => {
    const baseColor = isActive
        ? 'bg-mp-primary text-mp-primary-foreground'
        : isComplete
          ? 'bg-mp-success text-mp-success-content'
          : 'bg-mp-secondary-content text-mp-secondary';

    const stepRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isActive && stepRef.current) {
            stepRef.current.scrollIntoView({
                behavior: 'smooth',
                inline: 'start',
                block: 'nearest',
            });
        }
    }, [isActive]);

    return (
        <div
            ref={stepRef}
            className={clsx('relative flex items-center flex-1 min-w-[10rem]', className)}
            style={{ zIndex }}
        >
            <span
                aria-current={isActive ? 'step' : undefined}
                className={buttonClassName({
                    variant: 'clear',
                    size: 'sm',
                    className: clsx(
                        baseColor,
                        'px-2 py-2 text-center font-medium w-full transition-colors duration-300',
                        isFirst && 'rounded-bl-full rounded-tl-full',
                        !isLast && 'clip-arrow-right'
                    ),
                })}
            >
                {label}
            </span>
        </div>
    );
};
